export const environment = {
  production: false,  
  version: '1.0.0',
  url: 'https://wscartadocumentoqas.ocasa.com'
};
